// extracted by mini-css-extract-plugin
export default {"SensitivitiesStep":"SensitivitiesStep_SensitivitiesStep__JxXDt","SensitivitiesStep-heading":"SensitivitiesStep_SensitivitiesStep-heading__WBNPy"};